/**
 * NZ-locale date formatting helpers.
 *
 * Use these wherever a date is rendered to the user. Backend / database
 * date storage is untouched — these are display-only.
 *
 * Format: dd/mm/yyyy (NZ default via the `en-NZ` locale tag).
 */

const NZ = 'en-NZ';

/** dd/mm/yyyy — e.g. 11/02/2026 */
export const formatDateNZ = (input) => {
  if (!input) return '—';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString(NZ); // dd/mm/yyyy
  } catch {
    return '—';
  }
};

/** 11 Feb 2026 — short month variant for headings/cards */
export const formatDateNZShort = (input) => {
  if (!input) return '—';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString(NZ, { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '—';
  }
};

/** 11/02/2026, 14:32 */
export const formatDateTimeNZ = (input) => {
  if (!input) return '—';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleString(NZ, {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
  } catch {
    return '—';
  }
};

/** Relative — "Today", "2 days ago", "3 mo ago" */
export const formatRelativeNZ = (input) => {
  if (!input) return 'Never';
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return '—';
    const diff = Date.now() - d.getTime();
    const days = Math.floor(diff / 86400000);
    if (days < 0) return formatDateNZ(input); // future
    if (days === 0) return 'Today';
    if (days === 1) return '1 day ago';
    if (days < 30) return `${days} days ago`;
    if (days < 365) return `${Math.floor(days / 30)} mo ago`;
    return `${Math.floor(days / 365)} yr ago`;
  } catch {
    return '—';
  }
};
